module.exports = __webpack_public_path__ + "static/Face-Ollie.79b029f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Face-Ollie.jpg
// module id = 489
// module chunks = 144251824217401